/* eslint-disable import/prefer-default-export */
export const capitalizePhrase = (text) => {
  const textLowerCase = `${text.toLowerCase()} `;
  return textLowerCase
    .split(' ')
    .map((el) => el.charAt(0).toUpperCase() + el.slice(1))
    .join(' ')
    .trim();
};
export const insertStringAfterBeforeCharOrString = (
  mainString,
  insertString,
  charOrWordToSearch,
  strict = true
) => {
  const position = strict
    ? mainString.indexOf(charOrWordToSearch)
    : mainString.toLocaleLowerCase().indexOf(charOrWordToSearch.toLocaleLowerCase());
  if (position !== -1) return `${mainString.slice(0, position)}<br />${mainString.slice(position)}`;
  return mainString;
};

export const getAlphanumericRandomString = (length) => {
  const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result1= '';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i += 1 ) {
      result1 += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result1;

}